<div class="col-12 no-padding p-3 d-flex justify-content-between w-100 h-100">
    <div class="first-col" *ngIf="!isMobile">
        <div class="card bg-white p-3 rounded incident system-prompt">
            <div class="form-background">
                <div class="card-body d-flex flex-column justify-content-center align-items-center">
                    AIP+ Metered Stage 0 Deck
                    <button class="col-md-2 download-deck mt-3" type="button" (click)="downloadMeteredDoc()">
                        <span class="spacing">
                            <!-- <fa-icon [icon]="downloadIcon"></fa-icon> -->
                            Download</span>
                    </button>
                </div>
            </div>
        </div>
    </div>
    <div class="second-col">
        <div class="row d-flex justify-content-center">
            <div class="col-md-12 col-lg-12 col-xl-12">
                <div class="card" id="chat2" #pdfDashboard>
                    <div #chatScroll class="card-body chat-scroll" data-mdb-perfect-scrollbar="true">
                        <ng-container *ngFor="let message of messages;">
                            <div class="col-md-12 col-lg-12 col-xl-12 d-flex flex-row justify-content-end align-items-start"
                                *ngIf="message.author === 'user'">
                                <div class="d-flex flex-column align-items-end">
                                    <p class="medium p-3 ms-3 mb-1 rounded-3 lh-base user"
                                        [innerHTML]="message.content"></p>
                                    <p class="small ps-3 ms-3 mb-3 rounded-3 text-muted">{{message.todayDate |
                                        customDate}}</p>
                                </div>
                                <div class="user-icon ms-2 p-8 rounded-circle d-flex">
                                    <img class="user-avatar" src="assets/images/user_icon.png" alt="avatar 1">
                                </div>
                            </div>
                            <div class="col-md-12 col-lg-12 col-xl-12 d-flex flex-row justify-content-start"
                                *ngIf="message.author === 'bot' && message.content.message">
                                <div class="acc-icon p-8 rounded-circle d-flex">
                                    <img class="bot-image" src="assets/images/acc_logo.svg" alt="avatar 1">
                                </div>
                                <div class="d-flex ms-2 flex-column align-items-start">
                                    <div class="position-relative">
                                        <p class="medium p-3 mb-1 rounded-3 lh-base bot">
                                            <!-- <app-typing [textToType]="message.content.message"
                                                [typeSpeed]="typeSpeed"></app-typing> -->
                                            <span [innerHTML]="message.content.message" class="botReply"></span>
                                            &nbsp;
                                            <span class="cursor"
                                                [style.visibility]="!message.stopCursor ? 'visible' : 'hidden'"></span>
                                        </p>
                                    </div>
                                    <p class="small ps-3 mb-3 mt-2 rounded-3 text-muted">{{message.todayDate |
                                        customDate}}</p>
                                </div>
                            </div>
                            <div class="col-md-12 col-lg-12 col-xl-12 d-flex flex-row justify-content-start"
                                *ngIf="message.showLoader">
                                <div class="acc-icon p-8 rounded-circle d-flex">
                                    <img class="bot-image" src="assets/images/acc_logo.svg" alt="avatar 1">
                                </div>
                                <div class="d-flex ms-2 flex-column align-items-center justify-content-center">
                                    <p class="medium p-3 mb-1 rounded-3 bot">Preparing response
                                        <img class="bot-image" src="assets/images/typing.gif" alt="typing"
                                            loading="lazy">
                                    </p>
                                </div>
                            </div>
                        </ng-container>
                        <div class="col-md-12 col-lg-12 col-xl-12 d-flex flex-row justify-content-start"
                            *ngIf="showError">
                            <div class="acc-icon p-8 rounded-circle d-flex">
                                <img class="bot-image" src="assets/images/acc_logo.svg" alt="avatar 1">
                            </div>
                            <div class="d-flex ms-2 align-items-center justify-content-center">
                                <p class="medium p-3 rounded-3 note note-danger error-message">
                                    An error occurred. Either the engine you requested does not exist or there was
                                    another issue processing your request.
                                </p>
                                <button class="btn btn-md ms-1 regenerate-btn" (click)="regenerate()">
                                    <img height="18" src="assets/images/regerate.svg" class="me-1">
                                    Regenerate
                                </button>
                            </div>
                        </div>
                    </div>
                    <div class="d-flex w-100 div-height rounded-3">
                        <div
                            class="bg-transparent text-muted d-flex justify-content-start align-items-center p-3 msg-div pe-0">
                            <div class="input-group mb-0 h-100">
                                <div class="d-flex w-100 align-items-center bg-white rounded-3 pe-2 shadow-4"
                                    [ngClass]="{'no-events': regenerateResponse}">
                                    <textarea type="text" class="form-control rounded-3 message-textarea"
                                        autocomplete="off" name="send_message" placeholder="Type a message"
                                        [(ngModel)]="prompt" id="send_message" (keydown.enter)="$event.preventDefault()"
                                        pattern="/^[/\S/]+$/i" (keyup.enter)="submit()"></textarea>
                                    <button class="send-btn" (click)="submit()" *ngIf="!showStop"
                                        [disabled]="(!prompt || prompt === '')"><img height="30" class="send-button"
                                            src="assets/images/send-button.svg"></button>
                                    <button class="send-btn" (click)="stop()" *ngIf="showStop"><img height="30"
                                            class="send-button" src="assets/images/Stop.png"></button>
                                </div>
                            </div>
                        </div>
                        <div class="bg-transparent d-flex align-items-center justify-content-center export-div pe-auto">
                            <button mat-icon-button [matMenuTriggerFor]="menu">
                                <img height="30" class="download-button pe-auto"
                                    src="assets/images/three dots_icon.svg">
                            </button>
                            <mat-menu #menu="matMenu">
                                <button mat-menu-item class="menu-btn menu-clr" (click)="downloadChatHistoryPDF()">
                                    Download Chat History
                                </button>
                                <button mat-menu-item class="menu-btn menu-clr" (click)="resetData()">
                                    Reset Chat
                                </button>
                            </mat-menu>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<app-loader [isShowLoader]="showLoader"></app-loader>